import React, { useEffect, useState } from "react";
import SlickSlider from "../SlickSlider/SlickSlider";
import UseCasesItem from "./UseCasesItem";

const USeCases = () => {
  const slickSettings = {
    dots: false,
    infinite: true,
    speed: 8000,
    autoplay: true,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  const slider_items = [
    {
      link: "/",
      title: "Trusted Value",
      description1:
        " Patients and clinicians earn DIAG by completing surveys or training AI—improving diagnostic accuracy and building a data-rich platform.",
    },
    {
      link: "/",
      title: "Interoperability",
      description1:
        "Use DIAG to pay for physiotherapy, orthotics, wearable devices, or even offset insurance costs—connecting all aspects of care.",
    },
    {
      link: "/",
      title: "Building Ecosystems",
      description1:
        " DIAG incentivizes data sharing from wearables and clinics, growing a collaborative network that strengthens AI and care delivery.",
    },
    {
      link: "/",
      title: "Real Value",
      description1:
        " Redeem DIAG for healthcare discounts, wellness services, and fitness rewards—delivering practical and financial benefits.",
    },
    {
      link: "/",
      title: "Pre-Sales Discounts",
      description1:
        " Early adopters access DIAG at discounted rates, fueling global expansion and rewarding early supporters.",
    },
    {
      link: "/",
      title: "Sustainable Growth",
      description1:
        " By tracking care plan adherence and integrating innovations like AR pain mapping, DIAG ensures long-term platform evolution.",
    },
    {
      link: "/",
      title: "Premium Feature Access",
      description1:
        " Unlock advanced diagnostics, treatment plans, and exclusive services within the Diagnostica App using DIAG.",
    },
    {
      link: "/",
      title: "Limited Supply",
      description1:
        " With only 500 million tokens available, DIAG is built for scarcity—driving long-term value for users and investors alike.",
    },
  ];

  const initalState = 0;
  const [count, setCount] = useState(initalState);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((old) => (old == 6 ? 0 : old + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const toMultiply = 100 / slider_items.length;

  return (
    <section className="choose-area pb-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <div className="section-title text-center mb-50">
              <h2 className="title">
                DIAG Token's <span> Use Cases </span>
              </h2>
              <p className="merriweather-sans mt-3">
                The <b>DIAG Token</b> powers a smarter, connected healthcare
                ecosystem. Here’s how it creates real-world impact:
              </p>
            </div>
          </div>
        </div>

        <div className="row choose-active">
          <SlickSlider settings={slickSettings}>
            {slider_items.map((item, index) => (
              <div key={index} className="col-lg-3">
                <UseCasesItem item={item} />
              </div>
            ))}
          </SlickSlider>
        </div>

        <div className="slide-progressbar">
          <div
            style={{
              // width: `${count * toMultiply}%`,
              backgroundSize: `${count * toMultiply}% 100%`,
            }}
            className="slide-filler"
          />
        </div>
      </div>
    </section>
  );
};

export default USeCases;
